<template>
    <v-card elevation="1">
        <div>
            <v-card class="custom-table-ui header-filters pa-3" flat>
                <v-row>
                    <v-col md="3" lg="3" cols="12" class="mr-auto">
                        <v-text-field v-model="dataTable.search" label="Search here" placeholder="Search here" prepend-inner-icon="search" solo dense flat color="primaryTextColor" clearable hide-details />
                    </v-col>
                </v-row>
            </v-card>
            <v-divider></v-divider>

            <v-data-table
                class="custom-table-ui no-loading-bar"
                v-model="dataTable.selected"
                item-key="_id"
                :headers="dataTable.headers"
                :items="dataTable.data"
                :loading="dataTable.loading"
                loader-height="0"
                loading-text="Loading data..."
                :page.sync="dataTable.currentPage"
                :items-per-page.sync="dataTable.itemLength"
                :sort-by.sync="dataTable.sortBy"
                :sort-desc.sync="dataTable.sortDesc"
                :custom-sort="(items) => items"
                hide-default-footer
            >
                <template v-slot:[`item.status`]="{ item }">
                    <div :class="['status', item.status]">{{ item.status }}</div>
                </template>

                <template v-slot:[`item.logged_at`]="{ item }">
                    <div v-if="item.logged_at != ''">
                        {{ item.logged_at | moment('MMM DD, YYYY HH:mm:ss') }}
                    </div>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                    <div class="action">
                        <v-menu min-width="160px">
                            <template v-slot:activator="{ on: menu, attrs }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on: tooltip }">
                                        <v-icon class="mr-2" v-bind="attrs" v-on="{ ...tooltip, ...menu }">mdi-dots-vertical</v-icon>
                                    </template>
                                    <span>More</span>
                                </v-tooltip>
                            </template>

                            <v-list>
                                <v-list-item dense @click="viewDetails(item.id)">View Details</v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </template>
            </v-data-table>

            <v-card class="data-table-footer d-flex align-center justify-space-between flex-wrap border-radius-10 py-0" flat color="primaryBackgroundColor">
                <div class="flex-md-grow-0 flex-sm-grow-0 flex-grow-1 d-flex align-center justify-center py-2 px-3">
                    <span>Show</span>
                    <v-select class="item-length mx-2" v-model="dataTable.itemLength" :items="[10, 20, 50, 100]" solo dense flat background-color="secondaryBackgroundColor" hide-details />
                    <span class="px-0" md="auto" sm="auto" cols="auto">items per page</span>
                </div>
                <v-pagination class="flex-md-grow-0 flex-sm-grow-0 flex-grow-1 justify-center py-2" v-model="dataTable.currentPage" :length="dataTable.totalPages" :total-visible="7"></v-pagination>
            </v-card>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'MerchantDataTable',
    props: {
        details: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            dataTable: {
                loading: true,
                search: '',
                merchant_type: 'all',
                batch_number: 'all',
                itemLength: 10,
                currentPage: 1,
                totalPages: 1,
                selected: [],
                sortBy: [],
                sortDesc: [],
                headers: [
                    { text: 'User', value: 'actor_name', width: '240px' },
                    { text: 'Module', value: 'object_type', width: '160px' },
                    { text: 'Action', value: 'action', width: '260px' },
                    { text: 'Remarks', value: 'remarks', width: '220px' },
                    // { text: 'Date Created', value: 'created_at' },
                    { text: 'Event Date', value: 'logged_at', width: '160px' },
                    {
                        text: '',
                        value: 'actions',
                        sortable: false,
                        class: ['sticky', 'right'],
                        cellClass: ['sticky', 'right'],
                        width: '60px'
                    }
                ],
                data: []
            }
        };
    },
    computed: {
        list() {
            return this.$store.getters['auditTrails/getAuditTrails'];
        }
    },

    watch: {
        list(to) {
            if (to) {
                this.dataTable.loading = false;
                this.dataTable.totalPages = to.meta.last_page;
                this.dataTable.data = to.data; // to.data

                window.scrollTo(0, 0);
            }
        },
        'dataTable.search'() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.dataTable.currentPage = 1;
                this.getData({ cancel_current_api_call: true });
            }, 300);
        },
        'dataTable.itemLength'() {
            this.dataTable.currentPage = 1;
            this.getData({ cancel_current_api_call: true });
        },
        'dataTable.currentPage'() {
            this.getData({ cancel_current_api_call: true });
        },
        'dataTable.sortBy'() {
            const sortBy = this.dataTable.sortBy[0],
                sortDesc = this.dataTable.sortDesc[0];

            if (sortBy != undefined && sortDesc != undefined && sortDesc != true) {
                this.getData({ cancel_current_api_call: true });
            } else if (sortBy == undefined && sortDesc == undefined) {
                this.getData({ cancel_current_api_call: true });
            }
        },
        'dataTable.sortDesc'() {
            const sortBy = this.dataTable.sortBy[0],
                sortDesc = this.dataTable.sortDesc[0];

            if (sortBy != undefined && sortDesc != undefined) {
                this.getData({ cancel_current_api_call: true });
            } else if (sortBy == undefined && sortDesc == undefined) {
                this.getData({ cancel_current_api_call: true });
            }
        }
    },
    methods: {
        initiate() {
            this.getData();
        },
        getData(payload) {
            let { cancel_current_api_call } = payload || {};

            if (cancel_current_api_call) {
                this.$api.cancelCurrentApiCall();
            }

            this.dataTable.loading = true;

            const { search, itemLength, currentPage, sortBy, sortDesc } = this.dataTable;
            this.$store
                .dispatch('auditTrails/fetchAuditTrails', {
                    config: {
                        params: {
                            appends: ['actor'],
                            'filters[keyword]': search || undefined,
                            per_page: itemLength,
                            page: currentPage,
                            sort_by: sortBy[0],
                            order: sortDesc[0] != undefined ? (!sortDesc[0] ? 'asc' : 'desc') : undefined
                        }
                    }
                })
                .then(() => {})
                .catch(() => {
                    this.dataTable.loading = false;
                });
        },
        filterData() {
            this.getData({ cancel_current_api_call: true });
        },
        viewDetails(id) {
            // View Details
            this.$router.push({ name: 'audit-trails-details', params: { id: id } });
        }
    },
    mounted() {
        this.initiate();
    }
};
</script>

<style lang="scss" scoped>
.merchant-empty {
    min-height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
}

::v-deep {
    .text-start {
        &:last-of-type {
            text-align: center !important;
            button {
                margin-right: 0 !important;
            }
        }
    }
}
</style>
